import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useHighFrequencyRefreshQuery} from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import {IQuestionnaires, Questionnaires} from '../Questionnaires.ts';
import {QuestionnairesApi} from '../../../apis/QuestionnairesApi/QuestionnairesApi.ts';

export function useGetQuestionnaires(showInMedicalOverview: boolean = false, patientId?: number) {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.questionnaires, 'getQuestionnaires', showInMedicalOverview, patientId],
        queryFn: async () => {
            const result: IQuestionnaires[] = await QuestionnairesApi.getQuestionnaires(showInMedicalOverview, patientId);
            return result ? result.map((x) => new Questionnaires(x)) : result;
        },
        enabled: !showInMedicalOverview || patientId !== undefined,
    });
}